global.DigitalMediaAction = {

    init: function( uniqueID, iframeURL ) {
        this.uniqueID = uniqueID;
        this.mediaIframeClassName = '.media-iframe-'+uniqueID;
        this.mediaIframeName = 'iframe-'+uniqueID;
        this.digitalMediaPlayBtn = '#dm_js_auth-' + uniqueID;
        this.iframeURL = iframeURL;
        this.dmIframeWindow;
        this.checkIfIframeLoaded();
    },
    checkIfIframeLoaded: function(){
        var $this = this;
        var iframeEL = document.getElementById( this.mediaIframeName );
        var isLoaded = false;

        // show iframe on load.
        iframeEL.onload = function(){
            $( '#spinner-' + $this.uniqueID ).addClass( 'd-none' );
            $( $this.mediaIframeClassName ).removeClass( 'hide-iframe' );
            isLoaded = true;
        }

        // Check if iframe loaded after 1s.
        // Worst case, assume auth session expired and show popup play btn to re-auth.
        setTimeout(function() {
            if( ! isLoaded ){
                $this.bindEvents();
            }
        }, 1000);
    },

    bindEvents: function () {
        var $this = this;
        
        // Show play button and hide iframe and spinner.
        this.toggleButtonControls();

        $( 'body' ).on('click', this.digitalMediaPlayBtn, function () {
            $this.loadUpPopup();
        });
    },

    toggleButtonControls: function ( isLoading, showIframe ) {
        if ( isLoading ) {
            // show spinner.
            $( '#mi-container-' + this.uniqueID ).css("background-color", "#ccc");
            $( '#spinner-' + this.uniqueID).removeClass( 'd-none' );
            $( '#dm-play-container-' + this.uniqueID ).addClass( 'd-none' );
            $( this.mediaIframeClassName ).removeClass( 'hide-iframe' );
        }else if( showIframe ){
            // show iframe.
            $( '#spinner-' + this.uniqueID ).addClass( 'd-none' );
            $( this.mediaIframeClassName ).removeClass( 'hide-iframe' );
            $( '#dm-play-container-' + this.uniqueID ).addClass( 'd-none' );
        }else {
            // show play btn.
            $( '#spinner-' + this.uniqueID ).addClass( 'd-none' );
            $( this.mediaIframeClassName ).addClass( 'hide-iframe' );
            $( '#dm-play-container-' + this.uniqueID ).removeClass( 'd-none' );
        }
    },

    loadUpPopup: function () {
        this.toggleButtonControls( true );
        var top = (screen.height / 2) - (360 / 2);
        var left = (screen.width / 2) - (650 / 2);
        this.dmIframeWindow = window.open( 
            this.iframeURL, 
            "dmIframeVideo", 
            "width=650,height=360,left=" + left + ",top=" + top );
        this.runLooper();
    },

    runLooper: function(){
        var $this = this;
        var pixelCheckerLoop;
        pixelCheckerLoop = setInterval(function () {
            // Re-add iframe.
            var iframe = $('#' + $this.mediaIframeName);
            $('#' + $this.mediaIframeName).remove();
            $( '#dm-play-container-' + $this.uniqueID ).after( iframe );

            // Check if new iframe loads.
            var newIframe = document.getElementById($this.mediaIframeName);
            newIframe.onload = function() {
                $this.toggleButtonControls(false, true);
                clearInterval(pixelCheckerLoop);
                $this.dmIframeWindow.close();
            }
        }, 500);
    }
}
